// Pokémon card game data - ranked by popularity (based on official polls, merchandise, and fan reception)
export const POKEMON_CARDS = [
  { id: 1, name: "Pikachu", rank: 1, image: "/images/pokemon/pokemon_1.jpg" },
  { id: 2, name: "Charizard", rank: 2, image: "/images/pokemon/pokemon_2.jpg" },
  { id: 3, name: "Mewtwo", rank: 3, image: "/images/pokemon/pokemon_3.jpg" },
  { id: 4, name: "Eevee", rank: 4, image: "/images/pokemon/pokemon_4.jpg" },
  { id: 5, name: "Gengar", rank: 5, image: "/images/pokemon/pokemon_5.jpg" },
  { id: 6, name: "Lucario", rank: 6, image: "/images/pokemon/pokemon_6.jpg" },
  { id: 7, name: "Greninja", rank: 7, image: "/images/pokemon/pokemon_7.jpg" },
  { id: 8, name: "Umbreon", rank: 8, image: "/images/pokemon/pokemon_8.jpg" },
  { id: 9, name: "Garchomp", rank: 9, image: "/images/pokemon/pokemon_9.jpg" },
  { id: 10, name: "Rayquaza", rank: 10, image: "/images/pokemon/pokemon_10.jpg" },
  { id: 11, name: "Mimikyu", rank: 11, image: "/images/pokemon/pokemon_11.jpg" },
  { id: 12, name: "Dragonite", rank: 12, image: "/images/pokemon/pokemon_12.jpg" },
  { id: 13, name: "Sylveon", rank: 13, image: "/images/pokemon/pokemon_13.jpg" },
  { id: 14, name: "Blaziken", rank: 14, image: "/images/pokemon/pokemon_14.jpg" },
  { id: 15, name: "Snorlax", rank: 15, image: "/images/pokemon/pokemon_15.jpg" },
  { id: 16, name: "Meowth", rank: 16, image: "/images/pokemon/pokemon_16.jpg" },
  { id: 17, name: "Gyarados", rank: 17, image: "/images/pokemon/pokemon_17.jpg" },
  { id: 18, name: "Bulbasaur", rank: 18, image: "/images/pokemon/pokemon_18.jpg" },
  { id: 19, name: "Squirtle", rank: 19, image: "/images/pokemon/pokemon_19.jpg" },
  { id: 20, name: "Jigglypuff", rank: 20, image: "/images/pokemon/pokemon_20.jpg" },
  { id: 21, name: "Mew", rank: 21, image: "/images/pokemon/pokemon_21.jpg" },
  { id: 22, name: "Psyduck", rank: 22, image: "/images/pokemon/pokemon_22.jpg" },
  { id: 23, name: "Arcanine", rank: 23, image: "/images/pokemon/pokemon_23.jpg" },
  { id: 24, name: "Ninetales", rank: 24, image: "/images/pokemon/pokemon_24.jpg" },
  { id: 25, name: "Lapras", rank: 25, image: "/images/pokemon/pokemon_25.jpg" },
  { id: 26, name: "Tyranitar", rank: 26, image: "/images/pokemon/pokemon_26.jpg" },
  { id: 27, name: "Absol", rank: 27, image: "/images/pokemon/pokemon_27.jpg" },
  { id: 28, name: "Espeon", rank: 28, image: "/images/pokemon/pokemon_28.jpg" },
  { id: 29, name: "Alakazam", rank: 29, image: "/images/pokemon/pokemon_29.jpg" },
  { id: 30, name: "Vaporeon", rank: 30, image: "/images/pokemon/pokemon_30.jpg" }
];
